export default {"src":"/_next/static/media/top.2008b626.svg","height":140,"width":262};